import "./FormikColorPickerComponent.scss";
import {FieldProps} from "formik";
import ColorPickerComponent from "../../color-picker/ColorPickerComponent";
import commonService from "../../../services/common.service";
import {useCallback} from "react";

interface FormikColorPickerComponentProps {
    formikField: FieldProps;
}

const FormikColorPickerComponent = (props: FormikColorPickerComponentProps) => {

    const {formikField} = props;
    const {field, form} = formikField;
    const {name, value} = field;
    const {setFieldTouched, validateField, setFieldValue} = form;

    const onValueChange = useCallback((value: any) => {
        let tempValue = commonService.rgbaToHex(value);
        (async () => {
            await setFieldValue(name, tempValue);
            await setFieldTouched(name);
            await validateField(name);
        })()
    }, [name, setFieldTouched, setFieldValue, validateField]);

    return (
        <div className={'formik-color-picker-component'}>
            <ColorPickerComponent themeColor={commonService.hexToRgba(value)}
                                  canEdit={true}
                                  onColorChange={onValueChange}
            />
        </div>
    );

};

export default FormikColorPickerComponent;